import React from 'react';

const EventImage = ({ image }) => {
  return (
    image.url &&
      <div className='pb-2'>
        <div className="d-flex position-relative w-100 overflow-hidden cui-event-img">
          <img className="position-absolute w-100 h-100 cui-event-img-bg" src={ image.url } alt={ image.alt }/>
          <img className="w-100 h-100 cui-img-contain" src={ image.url } alt={ image.alt }/>
        </div>
      </div>
  )
};

export default EventImage;
